import React from "react";
import styled from "styled-components";
import { DATA } from "../data/newsletterData";
import BlogSmallBox from "./BlogSmallBox";

function BlogList() {
  return (
    <Container>
      <div className="list">
        {DATA &&
          React.Children.toArray(
            DATA.map((data) => (
              <BlogSmallBox
                image={data.image}
                title={data.title}
                week={data.week}
                date={data.date}
                path={data.path}
              />
            ))
          )}
      </div>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  .list {
    width: min(100%, 600px);
    margin: 0 auto;
    padding: 30px 15px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    justify-content: center;
    gap: 15px;
    @media (max-width: 548px) {
      grid-template-columns: 1fr;
    }
  }
`;

export default BlogList;
